import { Record } from 'immutable';

export default class MileageAllowanceRecord extends Record({
  id: undefined,
  booking: undefined,
  createdAt: undefined,
  date: undefined,
  indicateHandle: undefined, // Used only be FE
  internalStatus: undefined, // Used only be FE
  kilometers: undefined,
  payment: undefined,
  resource: undefined,
  unitPrice: undefined,
}) {
}
